export default __webpack_public_path__ + "static/media/business-original.6fad54e7.jpeg";